module.exports = __webpack_public_path__ + "img/document-text-1.63de84c3.svg";